export const address = {
  addressStreetCombine: (streetUnit, streetNo, streetName, streetType) => {
    return `${streetUnit ? streetUnit + ' ' : ''}${
      streetNo ? streetNo + ' ' : ''
    }${streetName ? streetName + ' ' : ''}${
      streetType ? streetType : ''
    }`?.trim();
  },
  addressCombine: (
    streetUnit,
    streetNo,
    streetName,
    streetType,
    suburb,
    state,
    postalCode
  ) => {
    return `${address.addressStreetCombine(
      streetUnit,
      streetNo,
      streetName,
      streetType
    )}${`, `}${suburb ? suburb + ' ' : ''}${state ? state + ' ' : ''}${
      postalCode ? postalCode + ' ' : ''
    }`?.trim();
  },
  addressStreetSplitFromFullAddress: (fullAddress = '') => {
    if (!fullAddress) return '';
    const [addressStreet, addressPostcode] = fullAddress.split(',');
    if (!addressStreet) return '';
    return addressStreet;
  },
  addressPostcodeSplitFromFullAddress: (fullAddress = '') => {
    if (!fullAddress) return '';
    let [addressStreet, addressPostcode] = fullAddress.split(',');
    if (!addressPostcode) return '';
    addressPostcode = addressPostcode.trim();
    const addressPostcodeSplit = addressPostcode.split(' ');
    const postcode = addressPostcodeSplit.slice(-1)[0];
    const state = addressPostcodeSplit.slice(-2)[0];
    const suburb = addressPostcodeSplit.slice(0, -2).join(' ');
    return { addressPostcode, suburb, state, postcode };
  },
};
